import FloatingServiceMenu from '@/components/FloatingServiceMenu.vue';
export default {
  components: {
    FloatingServiceMenu
  },
  computed: {
    isHomePage() {
      // 判断是否是首页，可以根据路径或meta信息判断
      return this.$route.path === '/';
    }
  },
  async mounted() {
    this.$store.commit('changeLoginStatus');
    const areaList = await this.$utils.getAreaList();
    this.$store.commit('setAreaList', areaList);
  }
};